var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{staticClass:"panel container-medium",attrs:{"tabs":_vm.tabs,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }